import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/bricolage-grotesque"; // display / headings
import "@fontsource/dm-sans/400.css"; // body
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";
import "@fontsource/space-mono/400.css"; // data / labels
import "@fontsource/space-mono/700.css";
import { BrowserRouter } from "react-router";
import "./styles/index.css";
import App from "./App.jsx";

// BrowserRouter, not HashRouter: the Console is served at the root of its own host
// and every serving layer already falls back to index.html for an unknown path, so
// real paths resolve on a refresh and on a cold deep link. CloudFront maps 403/404
// to /index.html with a 200 (terraform live/dev/.../main.tf), the container image
// serves `try_files $uri $uri/ /index.html` (infra/nginx.conf), and Vite's dev
// server and `preview` do the same by default. Nothing needed adding for this.
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
